import {
    ChatBubbleOutlineOutlined,
    HealingOutlined,
    HealthAndSafetyOutlined,
    PhoneInTalkOutlined,
    ScheduleOutlined
} from '@mui/icons-material';
import DocPageLayout from './DocPageLayout.js';
import PhoneContactBlock from './PhoneContactBlock.js';
import './DocPage.css';
import { lineOfficialUrl, reservationUrl } from './navigationConfig.js';

const heroImage = '/img/private-reservation.jpg';
const secondaryImage = '/img/counseling-session.jpg';

const Reservation = () => (
    <DocPageLayout
        currentRoute="/reservation"
        pageLabel="CONTACT"
        pageTitle="ご予約・お問い合わせ"
        heroImage={heroImage}
        heroImageAlt="予約のイメージ"
        heroHighlight="完全予約制のプライベートサロン"
        heroDescription="公式LINEまたはSquare予約から受け付けています。初めての方も安心してご相談ください。"
    >
        <article className="doc-section">
            <h3 className="doc-section__title">
                <ScheduleOutlined className="doc-section__icon" />ご予約について
            </h3>
            <div className="doc-section__body">
                <p>
                    当院は完全予約制のプライベートサロンです。ご予約は公式LINEまたはSquare予約から承っております。ご不明点がございましたら、お気軽にお問い合わせください。
                </p>
                <div className="doc-contact">
                    <a
                        className="access-actions__button access-actions__button--primary"
                        href={reservationUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Square予約ページへ
                    </a>
                    <a
                        className="access-actions__button access-actions__button--line"
                        href={lineOfficialUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        LINEで友達追加
                    </a>
                </div>
                <div className="doc-section__media">
                    <img src={secondaryImage} alt="カウンセリングの様子" loading="lazy" />
                </div>
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <ChatBubbleOutlineOutlined className="doc-section__icon" />初めてお越しの方へ
            </h3>
            <div className="doc-list">
                <li>
                    <ScheduleOutlined className="doc-list__icon" />
                    <span className="doc-list__content">
                        <strong>1. 予約</strong>
                        公式LINEまたはSquare予約からお申し込みください。ご不明点はLINEへお気軽にどうぞ。
                    </span>
                </li>
                <li>
                    <ChatBubbleOutlineOutlined className="doc-list__icon" />
                    <span className="doc-list__content">
                        <strong>2. 受付</strong>
                        予約日時にご来院ください。カウンセリングシートのご記入をお願いいたします。
                        <img
                            className="doc-list__image"
                            src="/contact/2.webp"
                            alt="受付の様子"
                            loading="lazy"
                        />
                    </span>
                </li>
                <li>
                    <ChatBubbleOutlineOutlined className="doc-list__icon" />
                    <span className="doc-list__content">
                        <strong>3. 問診</strong>
                        カウンセリングシートをもとに、症状やお悩みを詳しく伺います。初回は約30分かけて丁寧にヒアリングします。
                        <img
                            className="doc-list__image"
                            src="/contact/3.webp"
                            alt="問診の様子"
                            loading="lazy"
                        />
                    </span>
                </li>
                <li>
                    <HealthAndSafetyOutlined className="doc-list__icon" />
                    <span className="doc-list__content">
                        <strong>4. 検査</strong>
                        視診・触診に加え、姿勢分析や可動域検査、筋力検査など必要に応じて実施します。
                        <img
                            className="doc-list__image"
                            src="/contact/4.webp"
                            alt="検査の様子"
                            loading="lazy"
                        />
                    </span>
                </li>
                <li>
                    <HealingOutlined className="doc-list__icon" />
                    <span className="doc-list__content">
                        <strong>5. 施術</strong>
                        お着替えの上、神経整体と鍼灸を組み合わせたボキボキしない施術を進めていきます。
                        <img
                            className="doc-list__image"
                            src="/contact/5.webp"
                            alt="施術の様子"
                            loading="lazy"
                        />
                    </span>
                </li>
                <li>
                    <ChatBubbleOutlineOutlined className="doc-list__icon" />
                    <span className="doc-list__content">
                        <strong>6. 説明</strong>
                        今後の治療方針や注意点をお伝えします。ご不明点は何でもご質問ください。
                        <img
                            className="doc-list__image"
                            src="/contact/6.webp"
                            alt="治療方針の説明"
                            loading="lazy"
                        />
                    </span>
                </li>
                <li>
                    <ScheduleOutlined className="doc-list__icon" />
                    <span className="doc-list__content">
                        <strong>7. 会計</strong>
                        次回予約とお会計を済ませて終了です。
                    </span>
                </li>
            </div>
            <p className="doc-note">
                ※慢性的な痛みや不調がある方に施術枠を確保したいため同業の方はお断りさせていただいております。
            </p>
            <p className="doc-note">
                ※ご不明な点がございましたら、お気軽にお問い合わせください。
            </p>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <ChatBubbleOutlineOutlined className="doc-section__icon" />お問い合わせ
            </h3>
            <div className="doc-section__body">
                <p>
                    お問い合わせはLINE公式アカウントから承っております。返信にお時間をいただく場合がございますので、あらかじめご了承ください。
                </p>
                <div className="doc-contact__line">
                    <img
                        className="doc-contact__line-qr"
                        src="/contact/line_qrcode.png"
                        alt="LINE公式アカウントQRコード"
                        loading="lazy"
                    />
                    <a
                        className="access-actions__button access-actions__button--line"
                        href={lineOfficialUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        LINE公式アカウント
                    </a>
                </div>
                <p className="doc-note">LINE ID：@478qnxkr</p>
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <PhoneInTalkOutlined className="doc-section__icon" />お電話でのお問い合わせ
            </h3>
            <div className="doc-section__body">
                <PhoneContactBlock />
            </div>
        </article>
    </DocPageLayout>
);

export default Reservation;
